<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Notify from '@/common/Notify'
import Storage from '@/common/Storage'
import Request from '@/common/Request'
import Common from '@/common/Common'
export default {
    name: 'App',
    data : function(){
        return {
            'navs' : [
                {
                    'name' : '首页',
                    'href' : '/',
                },{
                    'name' : '通行证',
                    'href' : '/user',
                },{
                    'name' : '充值中心',
                    'href' : '/recharge',
                },{
                    'name' : '客服中心',
                    'href' : '/service',
                },{
                    'name' : '人才招聘',
                    'href' : '/job',
                },{
                    'name' : '关于应答',
                    'href' : '/about',
                },
            ],
            'navActive' : 0,
            'user' : false
        }
    },
    methods : {
        //退出登录
        logout : function(){
            this.user = false
            Storage.remove('user')
            Common.toUrl('/login')
            return true
        },

        //设置用户
        setUser : function(user){
            Storage.set('user', user)
            this.user = user
        },
        
        //更新用户信息
        updateUser : function(){
            var url = Request.createApi('/app/user/detail')
            Request.get(url, res => {
                this.user = res.info
            })
        },

        toUrl : function(url){
            Common.toUrl(url)
        },
    },
    created : function(){
        Request.getLoginUser(user => {
            this.setUser(user)
        })

        this.user = Storage.get('user')

        //路由确认
        for(var k in this.navs){
            var nav = this.navs[k]
            if(this.$route.path == nav.href){
                this.navActive = k
                break
            }
        }
    },
    mounted : function(){
        if ('-ms-scroll-limit' in document.documentElement.style 
            && '-ms-ime-align' in document.documentElement.style) {
            window.addEventListener('hashchange', () => {
                var currentPath = window.location.hash.slice(1)
                if (this.$route.path !== currentPath) {
                    this.$router.push(currentPath)
                }
            }, false)
        }
    },
    watch : {
        '$route': function(route) {
            var uri = route.path
            if(uri.indexOf('/user') === 0 
                || uri.indexOf('/login') === 0 
                || uri.indexOf('/register') === 0
            ){
                this.navActive = 1
            }else if(uri.indexOf('/recharge') === 0){
                this.navActive = 2
            }else if(uri.indexOf('/service') === 0){
                this.navActive = 3
            }else if(uri.indexOf('/job') === 0){
                this.navActive = 4
            }else if(uri.indexOf('/about') === 0){
                this.navActive = 5
            }else{
                this.navActive = 0
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue